import { forwardRef } from 'react'

import { AgGridReact } from 'ag-grid-react'

import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { CustomAgGridProps } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery } from '@fortem-monorepo/react-spa'
import { ICGuidelines } from '@fortem-monorepo/web-sdk'

const formatter = numberFormatter({
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  delimiter: true,
})

const goldExposureColDefs = createColDefs<ICGuidelines.DiversifiersData['gold_exposure'][number]>([
  {
    field: 'under_unique_identifier',
    headerName: 'Underlying',
  },
  {
    field: 'under_currency',
    headerName: 'Underlying Ccy',
  },
  {
    field: 'exposure_lcl',
    headerName: 'Local Exposure',
    valueFormatter: formatter,
  },
  {
    field: 'rate',
    valueFormatter: formatter,
  },
  {
    field: 'exposure_base',
    headerName: 'Base Exposure',
    valueFormatter: formatter,
  },
  {
    field: 'base_exposure_pct_of_total',
    headerName: 'Base Exposure (%)',
    valueFormatter: formatter,
  },
  {
    field: 'per_issue_over_nav_pct',
    headerName: '% Weight of Nav',
    valueFormatter: formatter,
    cellClassRules: {
      ['bg-red-200']: (params) => {
        return !!params.data?.above_threshold
      },
    },
  },
  {
    field: 'nav',
    valueFormatter: formatter,
  },
  {
    field: 'above_threshold',
    hide: true,
  },
  {
    field: 'fund_currency',
    headerName: 'Fund Ccy',
    hide: true,
  },
  {
    field: 'per_issue_over_nav',
    hide: true,
  },

  {
    field: 'under_instrument_id',
    hide: true,
  },
  {
    field: 'value_date',
    hide: true,
  },
])

export interface ICGuidelinesGoldExposureTableProps extends CustomAgGridProps {}

const ICGuidelinesGoldExposureTable = forwardRef<AgGridReact, ICGuidelinesGoldExposureTableProps>(
  ({ query, rowData }, forwardedRef) => {
    return (
      <Widget>
        <WidgetHeaderWithQuery query={query} title="Gold Exposure" />
        <WidgetContent loading={query?.isLoading}>
          <CustomAgGrid
            ref={forwardedRef}
            columnDefs={goldExposureColDefs}
            rowData={rowData}
            autoSizeStrategy={{
              type: 'fitCellContents',
            }}
          />
        </WidgetContent>
      </Widget>
    )
  },
)

export default ICGuidelinesGoldExposureTable
